import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'

export const UserRoutes = [
  {
    path: '/users',
    name: 'ListUsers',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'user:list'
    }
  },
  {
    path: '/user/',
    name: 'CreateUser',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'user:create'
    }
  },
  {
    path: '/user/:id',
    name: 'UpdateUser',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'user:update'
    }
  },
  {
    path: '/user/view/:id',
    name: 'GetUser',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'user:get'
    }
  }
]
